package com.shadowings.gero.presentation.component.quiz

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.presentation.component.GeroButton
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DevicePreviews
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.review_prompt_btn_later
import gero.composeapp.generated.resources.review_prompt_btn_rate
import gero.composeapp.generated.resources.review_prompt_feedback
import gero.composeapp.generated.resources.review_prompt_title
import org.jetbrains.compose.resources.stringResource

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun ReviewPromptPagePreview() {
    AppTheme {
        Surface {
            ReviewPromptPageComposable(
                userData = UserData(),
                onRateClick = {},
                onDismiss = {}
            )
        }
    }
}

// Rendered as a page inside the quiz's own HorizontalPager (see QuizScreen.kt), right after
// StreakCelebrationPageComposable — see that file's comment for why this is a page and not a
// global dialog.
@Composable
fun ReviewPromptPageComposable(
    userData: UserData,
    onRateClick: () -> Unit,
    onDismiss: () -> Unit
) {

    Box(modifier = Modifier.fillMaxSize()) {
        Column(
            modifier = Modifier
                .padding(24.dp)
                .fillMaxSize()
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Text(
                text = stringResource(Res.string.review_prompt_title),
                style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold),
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .semantics { testTag = "review_prompt_dialog_title" }
            )

            AlynFeedbackBox(
                face = Faces.Happy,
                text = stringResource(Res.string.review_prompt_feedback),
                userData = userData
            )

            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                TextButton(
                    onClick = onDismiss,
                    modifier = Modifier.semantics { testTag = "review_prompt_btn_later" }
                ) {
                    Text(
                        text = stringResource(Res.string.review_prompt_btn_later),
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                Spacer(Modifier.height(8.dp))
                GeroButton(
                    modifier = Modifier.height(64.dp).fillMaxWidth(),
                    title = stringResource(Res.string.review_prompt_btn_rate),
                    testTagId = "review_prompt_btn_rate"
                ) {
                    onRateClick()
                }
            }
        }
    }
}
